export default {
	propose: 'Stwórz własne wydarzenie i sprzedaj bilety online za pomocą usług KJMC.Kyiv!',
	description: 'Niezrównane doświadczenie zaczyna się od zakupu biletu!',
	moreEvents: 'Pokaż więcej wydarzeń',
	search: 'Szukaj'
}
